import React from 'react';
import classnames from 'classnames';
import { EtchWidgets } from '@thd-olt-component-react/etch-widgets';
import {
  arrayOf, bool, shape, string
} from 'prop-types';
import { Col, Row } from '@thd-olt-component-react/grid';
import { BulletList } from '../BulletList/BulletList';
import { InfoGuides } from '../InfoGuides/InfoGuides';
import './desktop-content.scss';
import { RevJet } from '../RevJet/RevJet';

const DesktopContent = (props) => {
  const {
    itemId,
    revJet,
    channel,
    description,
    documents,
    richContent,
    hideRichContents,
    preview,
    bullets,
    shouldShowMore,
    showRichContentsOnly,
    returnMessage,
    showReturnMessage
  } = props;

  const desktopContentClasses = classnames({
    'desktop-content-wrapper--show-less': shouldShowMore
  });

  const etchContent = richContent?.content;
  const displayInfoAndGuides = !!((documents || []).length && !showRichContentsOnly);

  // TODO: Clean this up, bad pattern.
  const thdGlobalDefined = typeof window !== 'undefined'
    && typeof window.THD_GLOBAL !== 'undefined'
    && window.THD_GLOBAL;
  const env = thdGlobalDefined ? 'prod' : 'qa';

  return (
    <div className="desktop-content-wrapper">
      {!etchContent && revJet
          && <RevJet itemId={itemId} envSpace={env} parentId="revJet-desktop-wrapper" />}
      <Row className={desktopContentClasses}>
        {etchContent && !hideRichContents
          && <EtchWidgets content={etchContent} /> }
        <Col fallback={displayInfoAndGuides ? '7' : '12'} className="desktop-content-wrapper__left-col">
          <Row className="desktop-content-wrapper__main-description">
            {!showRichContentsOnly ? description : null}
            {bullets && bullets.length
              && <BulletList bullets={bullets} margin isMobile={false} />}
          </Row>
        </Col>
        {displayInfoAndGuides && (
          <Col fallback="5">
            <InfoGuides
              documents={documents}
              channel={channel}
              returnMessage={returnMessage}
              showReturnMessage={showReturnMessage}
            />
          </Col>
        )}
      </Row>
    </div>
  );
};

const areEqual = (prevProps, nextProps) => {
  return prevProps.itemId === nextProps.itemId
  && prevProps.returnMessage === nextProps.returnMessage;
};

DesktopContent.displayName = 'DesktopContent';

DesktopContent.propTypes = {
  channel: string.isRequired,
  description: string.isRequired,
  documents: arrayOf(shape({
    name: string.isRequired,
    url: string.isRequired
  })).isRequired,
  hideRichContents: bool,
  preview: bool,
  richContent: shape({
    content: string,
    displayMode: string,
    url: string
  }),
  bullets: arrayOf(shape({})),
  shouldShowMore: bool,
  showRichContentsOnly: bool,
  returnMessage: string,
  showReturnMessage: bool,
  itemId: string.isRequired,
  revJet: bool

};

DesktopContent.defaultProps = {
  hideRichContents: false,
  preview: false,
  richContent: {},
  shouldShowMore: false,
  showRichContentsOnly: false,
  bullets: [],
  returnMessage: '',
  showReturnMessage: false,
  revJet: false
};

export default React.memo(DesktopContent, areEqual);
